import { render, staticRenderFns } from "./SearchClient.vue?vue&type=template&id=2726d6bb&scoped=true"
import script from "./SearchClient.vue?vue&type=script&lang=js"
export * from "./SearchClient.vue?vue&type=script&lang=js"
import style0 from "./SearchClient.vue?vue&type=style&index=0&id=2726d6bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726d6bb",
  null
  
)

export default component.exports